export default __webpack_public_path__ + "static/media/61.9c840692.gif";